import { Component } from 'react';
import { AlertTriangle } from 'lucide-react';
import { buttonClass, shellCard } from './shared.jsx';

function TariffModuleFallback({ error, onRetry }) {
  const isDev = import.meta.env.DEV;

  return (
    <section className={`${shellCard} p-6`}>
      <div className="rounded-2xl border border-[rgba(var(--danger),0.22)] bg-[rgba(var(--danger),0.08)] p-5">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-start gap-3">
            <AlertTriangle className="mt-0.5 h-5 w-5 text-[rgb(var(--danger))]" aria-hidden="true" />
            <div>
              <h2 className="text-base font-semibold text-[rgb(var(--fg))]">No se pudo cargar el simulador</h2>
              <p className="mt-1 text-sm text-[rgba(var(--fg),0.82)]">
                La navegación principal sigue disponible. Reintentá la carga sin salir del módulo de Tarifas.
              </p>
              {isDev && error?.message ? (
                <pre className="mt-3 overflow-x-auto rounded-xl bg-[rgba(var(--panel),0.55)] p-3 text-xs text-[rgba(var(--fg),0.84)]">
                  {error.message}
                </pre>
              ) : null}
            </div>
          </div>
          <button type="button" className={buttonClass} onClick={onRetry}>Reintentar</button>
        </div>
      </div>
    </section>
  );
}

export default class TariffModuleErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (import.meta.env.DEV) {
      // Mantiene el detalle visible sólo en desarrollo.
      console.error('Tariff module render error', error); // eslint-disable-line no-console
    }
  }

  handleRetry = () => {
    this.setState({ error: null });
    this.props.onRetry?.();
  };

  render() {
    if (this.state.error) {
      return <TariffModuleFallback error={this.state.error} onRetry={this.handleRetry} />;
    }

    return this.props.children;
  }
}
